<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/authentication/user.store.js'
import GbDialog from '@/components/GbDialog.vue'
import GbButton from '@/components/GbButton.vue'
import GbInlineMessage from '@/components/GbInlineMessage.vue'

const DIALOG_ID = 'terms-of-use-modal'

const userStore = useUserStore()
const { isAuthenticated, termsNotAccepted, userFirstName, terms_accepted_error: hasAcceptError } = storeToRefs(userStore)

const isShown = computed(() => isAuthenticated.value && termsNotAccepted.value)
</script>

<template>
  <GbDialog
    :dialog-id="DIALOG_ID"
    :visible="isShown"
    :show-close-icon="false"
    :dismissable-mask="false"
    :close-on-escape="false"
    show-header-content
    footer-buttons
  >
    <template #headerContent>
      <h2 :id="`${DIALOG_ID}_header`" class="w-full text-center text-display-sm font-[300]">
        Please Accept Our Updated Terms of Use
      </h2>
    </template>
    <template #bodyContent>
      <div class="text-text-lg font-[300]">
        <p class="fs-exclude">Hi {{ userFirstName }},</p>
        <p class="mb-2.5">We have recently updated our Terms of Use.</p>
        <a
          href="https://goalbook.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          class="text-link block border border-gray-200 p-2.5 text-center hover:bg-gray-200"
        >
          Click to view Terms of Use
        </a>
        <p class="mb-2.5 mt-6">To continue using Toolkit you must accept these updated terms.</p>
      </div>
      <GbInlineMessage v-if="hasAcceptError" gb-theme="red" class="w-full justify-center text-center">
        There was an error accepting the terms of use. Please try again. Contact support if issues persist.
      </GbInlineMessage>
    </template>
    <template #footerButtonRight>
      <GbButton id="accept-terms-btn" autofocus gb-theme="bluePrimary" label="I accept these terms" @click="userStore.acceptTerms()" />
    </template>
  </GbDialog>
</template>
